export default __webpack_public_path__ + "static/media/levelcomplete.bd1e2219.png";